export class SafetyEvidenceApi {
    client;
    constructor(client) {
        this.client = client;
    }
    /** Authorize an encrypted evidence reference (fails closed without consent, country permission, or encryption). */
    authorizeUpload(input) {
        return this.client.request({ method: 'POST', path: '/v1/safety-evidence', body: input, auth: true });
    }
    /** Log an access by the signed-in operator (D397: never a body accessor); refused once the evidence is DELETED → 409. */
    access(evidenceId, access) {
        return this.client.request({ method: 'POST', path: `/v1/safety-evidence/${encodeURIComponent(evidenceId)}/access`, body: access, auth: true });
    }
    /** Link the evidence to a safety incident/case for the investigation trail. */
    linkIncident(evidenceId, incidentId) {
        return this.client.request({ method: 'POST', path: `/v1/safety-evidence/${encodeURIComponent(evidenceId)}/link-incident`, body: { incidentId }, auth: true });
    }
    /** Place a legal hold — the reference is now exempt from retention purge and erasure until released. */
    placeLegalHold(evidenceId, caseId) {
        return this.client.request({ method: 'POST', path: `/v1/safety-evidence/${encodeURIComponent(evidenceId)}/legal-hold`, body: { caseId }, auth: true });
    }
    /** Release the legal hold (refused when no hold is in place → 409). */
    releaseLegalHold(evidenceId) {
        return this.client.request({ method: 'POST', path: `/v1/safety-evidence/${encodeURIComponent(evidenceId)}/legal-hold/release`, body: {}, auth: true });
    }
    /** Erase the evidence — state flips to DELETED and the storage key is cleared (blocked under legal hold → 409). */
    delete(evidenceId) {
        return this.client.request({ method: 'POST', path: `/v1/safety-evidence/${encodeURIComponent(evidenceId)}/delete`, body: {}, auth: true });
    }
    /** Read an evidence reference. */
    get(evidenceId) {
        return this.client.request({ method: 'GET', path: `/v1/safety-evidence/${encodeURIComponent(evidenceId)}`, auth: true });
    }
    /** List an incident's evidence (newest first). */
    listByIncident(incidentId) {
        return this.client.request({ method: 'GET', path: `/v1/safety-evidence?incidentId=${encodeURIComponent(incidentId)}`, auth: true });
    }
}
//# sourceMappingURL=safety-evidence.js.map